import { useQuery } from "@tanstack/react-query";
import { getVendors } from "../services/vendor-service";
import { GetVendorsResponse } from "../models/response/get-vendors-response";
import { ApiError } from "pages/admin-app/shared/models/response/api-errors";
import { ORDER_BY, PER_PAGE } from "pages/admin-app/adminapp.constants";

interface Props {
  currentPage: number;
  sortBy?: string;
  orderBy?: ORDER_BY;
  filters?: { [key: string]: string };
  searchQuery?: string;
}

export function useVendors({
  currentPage,
  sortBy,
  orderBy,
  filters,
  searchQuery,
}: Props) {
  const { data, error, isLoading, isError, refetch } = useQuery<
    GetVendorsResponse,
    ApiError
  >({
    queryKey: ["vendors", currentPage, sortBy, orderBy, filters, searchQuery],
    queryFn: () =>
      getVendors({
        page: currentPage,
        perPage: PER_PAGE,
        sortBy,
        orderBy,
        filters,
        searchQuery,
      }),
  });

  const baseErrorResponse = error ? error.message : null;

  return {
    data,
    error: baseErrorResponse,
    isLoading,
    isError,
    refetch,
  };
}
